import React from 'react';
import { connect } from 'react-redux';
import { yearMonthDay } from '../../../../actions/actionsDateTime';
//svgs
import GreyCalendar from '../../../../svgs/permit/GreyCalendar'
import { THEMES } from '../../../../dto/theme';
function FormTextInput({isPreview, sectionIdx, fieldIdx, fieldObj, handleUpdateData,control}) {
    const {fieldData:{title, data}, fieldId, fullWidth, required} = fieldObj
    function handleDateChange(val){
        handleUpdateData(val)
    }
    return (
    <div key={fieldId} className={'flex flex-col px-[12px] mt-[24px]' + (' w-[100%]')}>
        <div className='w-[50%]'>
            <label className='mb-[8px] text-[16px]'>{title}{required ? '*': ''}</label>
            <div className='rounded-full h-[33px] flex flex-row items-center px-[12px]' style={{border:control.theme===THEMES.DARK?'1px solid #FFFFFF80':'1px solid black'}}>
                {/* <GreyCalendar className='mr-[6px]'/> */}
                <input defaultValue={yearMonthDay(data)} onChange={(e) => handleDateChange(new Date(e.target.value).toString())} type='date' disabled={isPreview} className='bg-transparent h-[33px] w-full outline-none' style={{colorScheme: 'dark'}}></input>
            </div>
        </div>
    </div>)
}

export default connect((store) => {
    return {
      token: store.tokenReducer,
      control: store.controlReducer,
    }
  })(FormTextInput)